export const TAG_LOCALE_ZHCHT = {
    addText: 'æ·»å ',
    placeholder: 'è«è¼¸å¥'
};
